import WPInputLabel from "./WPInputLabel";

export default WPInputLabel;
